import { animate, query, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from 'app/shared/services/data/data.service';
import { FfvapiService } from 'app/shared/services/ffvApi/ffvapi.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

@Component({
  selector: 'app-search-user-licence',
  templateUrl: './search-user-licence.component.html',
  styleUrls: ['./search-user-licence.component.scss'],
  animations: [
    trigger('ask', [
      transition(':enter', [
        query('.wrap', [
          style({ opacity: 0, transform: 'translate(-200px)' }),
          animate('.17s', style({ opacity: 1, transform: 'none' })),
        ])
      ]),
    ]),
    trigger('linkYourAccount', [
      transition(':enter', [
        query('.wrap', [
          style({ opacity: 0, transform: 'translate(200px)' }),
          animate('.17s', style({ opacity: 1, transform: 'none' })),
        ])
      ]),
    ]),
  ]
})
export class SearchUserLicenceComponent extends SubscriptionBaseComponent implements OnInit {

  linkYourAccount: boolean;
  userIsLink: boolean;

  constructor(
    private dataService: DataService,
    private ffvService: FfvapiService,
    private router: Router

  ) {
    super();
  }

  ngOnInit(): void {
    this.initSub();
  }

  nextStep(): void {
    this.dataService.linkYourAccount.next(true);
  }

  private checkIfALicence(): void {
    this.ffvService.checkIfALicence().subscribe(res => {
      this.dataService.userIsLink.next(true);
    });
  }

  private initSub(): void {
    this.checkIfALicence();
    this.subscription
      .add(
        this.dataService.linkYourAccount.asObservable().subscribe(link => {
          this.linkYourAccount = link;
        })
      )
      .add(
        this.dataService.userIsLink.asObservable().subscribe(link => {
          this.userIsLink = link;
          if (this.userIsLink) {
            this.router.navigate(['/profil']);
          }
        })
      );
  }





}
